/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateClientSurveyDateDto
 */
export interface UpdateClientSurveyDateDto {
    /**
     * 
     * @type {Date}
     * @memberof UpdateClientSurveyDateDto
     */
    preparedDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof UpdateClientSurveyDateDto
     */
    sentDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof UpdateClientSurveyDateDto
     */
    answeredDate?: Date | null;
}

/**
 * Check if a given object implements the UpdateClientSurveyDateDto interface.
 */
export function instanceOfUpdateClientSurveyDateDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateClientSurveyDateDtoFromJSON(json: any): UpdateClientSurveyDateDto {
    return UpdateClientSurveyDateDtoFromJSONTyped(json, false);
}

export function UpdateClientSurveyDateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClientSurveyDateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'preparedDate': !exists(json, 'preparedDate') ? undefined : (json['preparedDate'] === null ? null : new Date(json['preparedDate'])),
        'sentDate': !exists(json, 'sentDate') ? undefined : (json['sentDate'] === null ? null : new Date(json['sentDate'])),
        'answeredDate': !exists(json, 'answeredDate') ? undefined : (json['answeredDate'] === null ? null : new Date(json['answeredDate'])),
    };
}

export function UpdateClientSurveyDateDtoToJSON(value?: UpdateClientSurveyDateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'preparedDate': value.preparedDate === undefined ? undefined : (value.preparedDate === null ? null : value.preparedDate.toISOString()),
        'sentDate': value.sentDate === undefined ? undefined : (value.sentDate === null ? null : value.sentDate.toISOString()),
        'answeredDate': value.answeredDate === undefined ? undefined : (value.answeredDate === null ? null : value.answeredDate.toISOString()),
    };
}

